import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import Typography from '../Typography';
import { getTextColorsFromSection } from '../lib/colors';

function Copyright({ classes, event, site, section }) {
  const { data } = section;
  const colors = getTextColorsFromSection(site, section);
  return (
    <div className={classes.root}>
      <a
        href="https://www.moblee.com.br/"
        rel="noopener noreferrer"
        target="_blank"
        className={classes.link}
      >
        <Typography style={colors.text}>{data.madeWithLove}</Typography>
        <svg className={classes.mobleeIcon} viewBox="0 0 50 50" style={{ fill: colors.text.color }}>
          <path d="M5.6,1.2c-0.5,0.3-0.9,0.9-1,1.9L1.3,37l13.4-12.4L5.6,1.2z" />
          <path d="M48.8,37L45.5,3.2c-0.2-1-0.5-1.6-1-1.9l-9.2,23.4L48.8,37z" />
          <path d="M1.1,39.3L1,39.8l0,0c-0.1,0.7,0.6,1.4,1.9,1.9L20,48c1.1,0.4,2.6,0.6,4,0.7l-8.7-22.5L1.1,39.3z" />
          <path d="M42.7,1.2c-0.4,0.2-0.9,0.5-1.3,0.9l-15.1,14l7.9,7.3L42.7,1.2z" />
          <path d="M23.8,16.2L23.8,16.2L23.8,16.2L8.7,2.2c-0.4-0.4-0.9-0.7-1.3-1L16,23.4L23.8,16.2z" />
          <path d="M26,48.8c1.4-0.1,2.9-0.2,4-0.7l17.1-6.3c1.4-0.5,2-1.2,1.9-1.9l0,0v-0.4L34.8,26.3L26,48.8z" />
          <path d="M25,17.3l-8.4,7.8l8.4,21.8l8.4-21.8L25,17.3z" />
        </svg>
      </a>
    </div>
  );
}

Copyright.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 2 * theme.spacing.unit,
    decoration: 'none',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  mobleeIcon: {
    marginLeft: theme.spacing.unit,
    width: 20,
    height: 20,
  },
});

export default injectSheet(stylesheet)(Copyright);



// WEBPACK FOOTER //
// ./src/site-render/src/FooterSection/Copyright.js